// Templates for info, warn, debug and error messages

export default {
  action: (action, controller) => `Successfully sent "${action}" action by ${controller}`,
  error: (res) => `${res.body.type}: ${res.body.message}`,
};



// WEBPACK FOOTER //
// ./src/utils/Logger/templates.js